/* Keep the homepage video black until the browser can present its first frame. */
(() => {
  const root = document.documentElement;
  const video = document.querySelector('.video-banner-with-intro video');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const paint = () => new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  let cancelWait = () => {};
  let generation = 0;

  const prepare = () => {
    const current = ++generation;
    cancelWait();
    if (!video || motion.matches || designMode) {
      root.classList.remove('home-video-pending');
      window.__sevenHomeVideoReady = Promise.resolve();
      return;
    }
    root.classList.add('home-video-page', 'home-video-pending');
    window.__sevenHomeVideoReady = new Promise((resolve) => {
      let finished = false;
      let frame = null;
      let checking = false;
      let fallback;
      const cleanup = () => {
        window.clearTimeout(fallback);
        ['loadeddata', 'canplay', 'playing'].forEach((type) => video.removeEventListener(type, check));
        video.removeEventListener('error', finish);
        if (frame !== null && video.cancelVideoFrameCallback) video.cancelVideoFrameCallback(frame);
      };
      const finish = async () => {
        if (finished) return;
        finished = true;
        cleanup();
        // Let the decoded frame reach the compositor before starting opacity.
        await paint();
        if (current === generation) root.classList.remove('home-video-pending');
        resolve();
      };
      const check = () => {
        if (finished || checking || video.readyState < 2) return;
        checking = true;
        if (typeof video.requestVideoFrameCallback === 'function' && !video.paused) {
          frame = video.requestVideoFrameCallback(finish);
        } else {
          // Older browsers, or a browser that refuses muted autoplay.
          finish();
        }
      };
      cancelWait = () => { if (!finished) { finished = true; cleanup(); resolve(); } };
      ['loadeddata', 'canplay', 'playing'].forEach((type) => video.addEventListener(type, check));
      video.addEventListener('error', finish);
      // A broken video must not block navigation: its configured poster is
      // revealed instead, and the rest of the page stays usable.
      fallback = window.setTimeout(finish, 12000);
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('playsinline', '');
      try {
        const playing = video.play();
        playing?.then(check).catch(() => { checking = false; check(); });
      } catch (error) { check(); }
      check();
    });
  };

  prepare();
  // Back/forward may restore a cached document without running its scripts.
  window.addEventListener('pageshow', (event) => { if (event.persisted) prepare(); });
  const motionChanged = () => { if (motion.matches) prepare(); };
  if (motion.addEventListener) motion.addEventListener('change', motionChanged);
  else motion.addListener(motionChanged);
})();
